import React, { useEffect, useRef, useState } from "react";
import * as faceapi from "face-api.js";
import one from "../assets/bg-img/one.jpg";
import heic2any from "heic2any";


const Test = () => {
  const referenceImageRef = useRef();
  const uploadedImageRef = useRef();
  const [uploadedFile, setUploadedFile] = useState(null);
  const [message, setMessage] = useState("");
  const [modelsLoaded, setModelsLoaded] = useState(false);

  useEffect(() => {
    const loadModels = async () => {
      const MODEL_URL = "https://justadudewhohacks.github.io/face-api.js/models";
      try {
        await faceapi.nets.ssdMobilenetv1.loadFromUri(MODEL_URL);
        await faceapi.nets.faceLandmark68Net.loadFromUri(MODEL_URL);
        await faceapi.nets.faceRecognitionNet.loadFromUri(MODEL_URL);
        // console.log("✅ Models loaded successfully");
        setModelsLoaded(true);
      } catch (err) {
        console.error("❌ Error loading models:", err);
        setMessage("Failed to load models");
      }
    };
    loadModels();
  }, []);

  const handleFileChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;
  
    if (file.type === "image/heic" || file.name.endsWith(".heic")) {
      try {
        const convertedBlob = await heic2any({
          blob: file,
          toType: "image/jpeg",
          quality: 0.8,
        });
  
        const imageUrl = URL.createObjectURL(convertedBlob);
        setUploadedFile(imageUrl);
        setMessage("");
      } catch (error) {
        console.error("HEIC conversion error:", error);
        setMessage("❌ Failed to convert HEIC image");
      }
    } else {
      setUploadedFile(URL.createObjectURL(file));
      setMessage("");
    }
  };

  const compareFaces = async () => {
    if (!modelsLoaded) {
      setMessage("Models are still loading...");
      return;
    }

    if (!uploadedImageRef.current) {
      setMessage("Please upload an image first.");
      return;
    }

    const referenceDesc = await getFaceDescriptor(referenceImageRef.current);
    const uploadedDesc = await getFaceDescriptor(uploadedImageRef.current);

    if (referenceDesc && uploadedDesc) {
      const distance = faceapi.euclideanDistance(referenceDesc, uploadedDesc);
      setMessage(distance < 0.6 ? "✅ Same student detected" : "❌ Different student");
    } else {
      setMessage("⚠️ Face not detected in one of the images");
    }
  };

  const getFaceDescriptor = async (img) => {
    try {
      const detection = await faceapi
        .detectSingleFace(img)
        .withFaceLandmarks()
        .withFaceDescriptor();
      return detection?.descriptor || null;
    } catch (err) {
      console.error("Face detection error:", err);
      return null;
    }
  };

  return (
    <div style={{ marginTop: "100px", textAlign: "center" }}>
      <h1>Student Face Recognition</h1>
      <div>
        <p>🎓 Reference Image</p>
        <img ref={referenceImageRef} src={one} alt="Reference" width="100px" />
      </div>

      <div style={{ marginTop: "20px" }}>
        <p>📤 Upload Image to Compare</p>
        <input
          type="file"
          onChange={handleFileChange}
          accept="image/*"
          disabled={!modelsLoaded}
        />
        
        {uploadedFile && (
          <div style={{ marginTop: "10px" }}>
            <img ref={uploadedImageRef} src={uploadedFile} alt="Uploaded" width="100px" />
          </div>
        )}
      </div>

      <div style={{ marginTop: "20px" }}>
        <button onClick={compareFaces} disabled={!modelsLoaded || !uploadedFile}>
          Compare
        </button>
      </div>

      {message && <p style={{ marginTop: "20px", fontWeight: "bold" }}>{message}</p>}
    </div>
  );
};

export default Test;
